import Vuex, {StoreOptions} from 'vuex'
import user from './user/state'
import pharmacies from "./pharmacies/state";
import {RootState} from "./types";
import { format, lastDayOfMonth, addMonths, addDays, startOfMonth } from 'date-fns';
import {ru} from "date-fns/locale";
import beru from '@/store/beru/state';

const hostname = `${process.env.VUE_APP_MICROSERVICE_WFM}/`;
const hostnameArmZort = `${process.env.VUE_APP_MICROSERVICE_ARMZORT}/`;
const sidebarState = localStorage.getItem('sidebarCollapsed')

const store: StoreOptions<RootState> = {
    state: {
        date: '',
        currentDate: new Date(),
        currentMoth: null,
        currentMonthNumber: null,
        url: hostname,
        urlArmZort: hostnameArmZort,
        startPeriod: '',
        endPeriod: '',
        currentDays: [],
        selectedDate: null,
        hover: null,
        gurvRole: false,
        isOffice: false,
        offlineDirectorRole: false,
        offlineAdminRole: false,
        wfmReaderRole: false,
        beruAccessRole: false,
        pharmsHeadRole: false,
        extendedRole: false,
        axiosController: new AbortController(),
        shiftBuffer: null,
        hasUnsavedChanges: false,
        sidebarCollapsed: sidebarState !== null ? JSON.parse(sidebarState) : true,
        savedMonthApplied: false,
    },
    getters: {
        getCurrentDays: state => state.currentDays,
        getCurrentDate: state => state.currentDate,
        getCurrentMoth: state => state.currentMoth,
        getCurrentMonthNumber: state => state.currentMonthNumber,
        getSelectedDate: state => state.selectedDate,
        getGurvRole: state => state.gurvRole,
        getOfflineDirectorRole: state => state.offlineDirectorRole,
        getOfflineAdminRole: state => state.offlineAdminRole,
        getWFMReaderRole: state => state.wfmReaderRole,
        getBeruAccessRole: state => state.beruAccessRole,
        hover: state => state.hover,
        getShiftBuffer: state => state.shiftBuffer,
        getOfficeState: state => state.isOffice,
        hasUnsavedChanges: state => state.hasUnsavedChanges,
        getSidebarState: state => state.sidebarCollapsed,
        getSavedMonthApplied: state => state.savedMonthApplied
    },
    mutations: {
        setDate(state, payload) {
            state.currentDate = new Date(state.currentDate.getTime() + state.currentDate.getTimezoneOffset())
            state.date = format(state.currentDate, 'yyyy-MM-dd')
            state.currentMoth = format(state.currentDate, 'LLLL', {locale: ru})
            state.currentMonthNumber = +format(state.currentDate, 'M', {locale: ru})
            state.startPeriod = `${format(payload, 'yyyy')}-${format(payload, 'MM')}-01`
            state.endPeriod = format(addDays(lastDayOfMonth(payload), 1), 'yyyy-MM-dd')
            state.currentDays = []
            state.selectedDate = format(startOfMonth(payload), 'd.M.yyyy')
            const dayCount = 33 - new Date(state.currentDate.getFullYear(), state.currentDate.getMonth(), 33).getDate();
            for (let i = 0; i < dayCount; i++) {
                state.currentDays.push(format(new Date(`${format(payload, 'yyyy')}-${format(payload, 'MM')}-${i < 9 ? '0' : ''}${i + 1}`), 'EEEEEE', {locale: ru}))
            }
        },
        setMoth(state, payload) {
            state.currentDate = new Date(addMonths(new Date(state.currentDate.getTime() + state.currentDate.getTimezoneOffset()), payload))
            state.startPeriod = format(addMonths(new Date(state.startPeriod), payload), 'yyyy-MM-dd')
            state.endPeriod = format(addMonths(new Date(lastDayOfMonth(new Date(state.endPeriod))), payload), 'yyyy-MM-dd')
            state.currentMoth = new Date(state.startPeriod).toLocaleString('default', { month: 'long' })
        },
        hoverRow(state, payload) {
            state.hover = payload
        },
        clearDates(state) {
            state.currentDate = new Date()
            state.currentMoth = null
            state.currentMonthNumber = null
            state.savedMonthApplied = false
        },
        copyShift(state, payload) {
            state.shiftBuffer = payload
        },
        clearShiftBuffer(state) {
            state.shiftBuffer = null
        },
        setUnsavedChanges(state, payload) {
            state.hasUnsavedChanges = payload
        },
        setSidebarState(state, payload) {
            state.sidebarCollapsed = payload
            localStorage.setItem('sidebarCollapsed', JSON.stringify(payload))
        },
        resetSidebarState(state) {
            state.sidebarCollapsed = true
            localStorage.setItem('sidebarCollapsed', 'true')
        },
        setSavedMonthApplied(state, payload) {
            state.savedMonthApplied = payload
        }
    },
    modules: {
        user: user,
        data: pharmacies,
        beru: beru
    }
}

export default new Vuex.Store<RootState>(store)